import styled, { css } from 'styled-components';
import { getBounceTransition } from '../../utils/transitions';
import { isRightAligned, isLeftAligned } from '../../utils/variations';
import { COMPONENT_MARGIN_BOTTOM } from '../../constants';
import { UnstyledButton } from '../Buttons';
import { Image } from '../Image';
import { RichH1, RichH2, RichP1, RichH4 } from '../Typography';
import media from '../../utils/media';
export const HeroContainer = styled.section `
  outline: none;
  box-sizing: border-box;
  font-family: ${({ theme }) => theme.fontFamilyBase};
  position: relative;
  max-width: 100%;
  height: 640px;
  display: flex;
  align-items: center;
  margin-bottom: ${({ hasBottomMargin }) => hasBottomMargin ? `${COMPONENT_MARGIN_BOTTOM.DESKTOP}px` : `0px`};

  ${({ alignment, theme, desktopImage }) => `background: ${isLeftAligned(alignment)
    ? theme.heroBGLeftGradient
    : isRightAligned(alignment)
        ? theme.heroBGRightGradient
        : theme.heroBGOverlay}, url(${desktopImage}) center / cover no-repeat`};

  /* paddings & margins */
  ${({ alignment }) => isLeftAligned(alignment)
    ? css `
          padding-left: 165px;
        `
    : isRightAligned(alignment)
        ? css `
          padding-left: calc(50% + 10px);
          padding-right: 80px;
        `
        : css `
          justify-content: center;
        `}

  ${media.tablet} {
    ${({ theme, desktopImage }) => `background: ${theme.heroBGOverlay}, url(${desktopImage}) center / cover no-repeat`};
    ${({ alignment }) => isLeftAligned(alignment) || isRightAligned(alignment)
    ? css `
            padding: 0 46px;
          `
    : css `
            margin-left: auto;
            margin-right: auto;
          `}
  }

  ${media.mobile} {
    ${({ mobileImage, theme }) => `background: ${theme.heroBGOverlay}, url(${mobileImage}) center / cover no-repeat`};
    padding: 0 20px;
    margin-bottom: ${({ hasBottomMargin }) => hasBottomMargin ? `${COMPONENT_MARGIN_BOTTOM.MOBILE}px` : `0px`};
  }

  ${({ hasPaddingBottom }) => hasPaddingBottom &&
    css `
      padding-bottom: 120px !important;
    `}

  ${({ hasPaddingBotOnMobile }) => hasPaddingBotOnMobile &&
    css `
      ${media.mobile} {
        padding-bottom: 74px !important;
      }
    `}
`;
export const HeroBody = styled.div `
  box-sizing: border-box;
  max-width: 540px;
  text-align: left;

  ${({ alignment }) => !isLeftAligned(alignment) &&
    !isRightAligned(alignment) &&
    css `
      text-align: center;
      max-width: 729px;
      padding: 0px;

      ${media.tablet} {
        width: 540px;
      }
    `}

  ${media.mobile} {
    width: 100%;
    text-align: center;
    margin: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  *:last-child {
    margin-bottom: 0px;
  }
`;
export const Title = styled(RichH1) `
  margin-bottom: 20px;

  ${media.mobile} {
    margin-bottom: 10px;
  }
`;
// H2 styled as an H1
// Supports multiple Hero components on a page without repeating H1 elements
export const SecondaryTitle = styled(RichH2) `
  font-family: ${({ theme }) => theme.fontFamilyHeading};
  font-weight: normal;
  font-size: 70px;
  line-height: 70px;
  color: ${({ theme, asWhite, color }) => (asWhite && theme.primaryWhite) || (color && color) || theme.primaryBlack};
  letter-spacing: 0.01em;
  padding: 0;
  margin: 0;
  margin-bottom: 20px;

  ${media.mobile} {
    font-size: 48px;
    line-height: 52px;
    margin-bottom: 10px;
  }
`;
export const BodyText = styled(RichP1) `
  margin-bottom: 16px;

  ${media.mobile} {
    margin-bottom: 10px;
  }
`;
export const Subtitle = styled(RichH4) `
  margin-bottom: 30px;
`;
export const Badge = styled(Image) `
  height: 75px;
  width: 120px;
  border-radius: 3px;

  ${media.mobile} {
    height: 50px;
    width: 80px;
  }
`;
export const CTAContainer = styled.div `
  display: flex;
  align-items: center;

  ${({ alignment }) => isLeftAligned(alignment) || isRightAligned(alignment)
    ? css `
          justify-content: flex-start;
        `
    : css `
          justify-content: center;
        `}
`;
export const HeroBottomContent = styled.footer `
  box-sizing: border-box;
  position: absolute;
  display: ${({ alignment }) => (isLeftAligned(alignment) ? 'flex' : 'none')};
  justify-content: ${({ hasBadgeOnly, hasPlayBtnOnly }) => hasBadgeOnly ? 'flex-end' : hasPlayBtnOnly ? 'flex-start' : 'space-between'};
  align-items: center;
  width: 100%;
  bottom: 60px;
  left: 0px;
  padding: 0 165px;

  ${media.tablet} {
    padding: 0 46px;
  }

  ${media.mobile} {
    justify-content: ${({ hasBadgeOnly, hasPlayBtnOnly }) => hasBadgeOnly || hasPlayBtnOnly ? 'center' : 'space-between'};
    padding: 0 20px;
    bottom: 20px;
  }
`;
export const ContainerButton = styled(UnstyledButton) `
  position: absolute;
  bottom: 20px;
  left: calc(50% - 21px);
  height: 14.25px;
  width: 28.5px;
  stroke: ${({ theme }) => theme.primaryWhite};

  ${media.mobile} {
    display: none;
  }

  animation: ${getBounceTransition()} 0.75s ease 0s 1;
`;
